import { Inject, Injectable } from '@angular/core';
import { STATE_REPOSITORY, StatusRepository } from '@core/repositories/status.repository';
import { State } from '@shared/interfaces/state';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StatusService {
  constructor(
    @Inject(STATE_REPOSITORY) protected repository: StatusRepository
  ) {}

  getItems(): Observable<any> {
    return this.repository.getItems();
  }

  add(state: State): Observable<any> {
    return this.repository.add(state);
  }

  edit(state: State): Observable<any> {
    return this.repository.edit(state);
  }

  delete(item: any): Observable<any> {
    return this.repository.delete(item);
  }
}
